import heic2any from "heic2any";

/**
 * Check if a file is HEIC/HEIF format
 * @param {File} file - The file to check
 * @returns {boolean} - True if file is HEIC/HEIF
 */
export const isHeicFile = file => {
  const ext = (file.name || file.path || "").split(".").pop().toLowerCase();
  return ["heic", "heif"].includes(ext);
};

/**
 * Converts HEIC/HEIF files to JPEG format for browser compatibility
 * Returns original file if not HEIC/HEIF
 * @param {File} file - The file to convert
 * @returns {Promise<File|Blob>} - Converted JPEG blob or original file
 */
export const convertHeicToJpeg = async file => {
  if (isHeicFile(file)) {
    const outputBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.7
    });
    return outputBlob;
  }

  return file;
};
